import { Stack } from "@atlaskit/primitives-next";

import { CustomerNameAndLogoHeader } from "@/components/fastshift/src/common/customer-name-and-logo-header";
import { useRoutes } from "@/components/fastshift/src/common/hooks/useRoutes";
import { LegalBanner } from "@/components/fastshift/src/common/legal-footer/src/legal-banner";
import { RelationshipSection } from "@/components/fastshift/src/common/relationships";
import { getCurrentTime } from "@/components/fastshift/src/common/utils";
import { CustomerWelcomeBanner } from "@/components/fastshift/src/common/welcome-banner";
import { useFastshiftSelector } from "@/components/fastshift/src/state";
import { useLoggedInUser } from "@/utils/logged-in-user-provider";

import { useDashboardPageAnalytics } from "./hooks";
import { MigrationTicketsList } from "./migration-tickets-list";
import { SummarySection } from "./summary-section";

export const FastshiftDashboard = () => {
    const { data: userDetails } = useFastshiftSelector(
        (state) => state.userDetails
    );

    const { paths } = useRoutes();

    const userInfo = useLoggedInUser();
    const currentTime = getCurrentTime();

    useDashboardPageAnalytics();

    return (
        <Stack space="space.400">
            {userDetails?.userType === "CUSTOMER" && (
                <Stack space="space.300">
                    <CustomerWelcomeBanner
                        currentTime={currentTime}
                        userName={userInfo?.name}
                    />
                    <LegalBanner />
                </Stack>
            )}
            {userDetails?.userType !== "CUSTOMER" && (
                <CustomerNameAndLogoHeader />
            )}
            <SummarySection />
            <MigrationTicketsList
                migrationTicketsUrl={paths.domainScopedTickets}
            />
            <RelationshipSection />
        </Stack>
    );
};
